import { gqlTagRest } from '@atlassian/jira-common-graphql-tags';

export { showErrorFlag, SHOW_ERROR_FLAG_FROM_SWAG } from './common/constants';
export { extractFlagFromAction, getErrorFlag } from './services/error-to-flag';
export type { ShowErrorFlagAction } from './common/constants';
export { mutation$ } from './services/mutation';
export { query$ } from './services/query';
export { SwagError, isFetchError, isSwagError, isJson } from './common/utils/error';
export type { GraphqlError } from './common/types';
export {
	logApolloError,
	logApolloNetworkError,
	logApolloRetry,
	logRestParsingError,
} from './services/log-error';
export const gqlTagSwag = gqlTagRest;
